// extracted by mini-css-extract-plugin
export default {"counter":"ExperienceCounter_counter__XIWGi","animate":"ExperienceCounter_animate__e837y"};